import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { ConfirmComponent } from 'src/app/support/confirm/confirm.component';
import { NotificationService } from 'src/app/services/notification.service';
import { ManufacturerService } from '../manufacturer.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Manufacturer } from 'src/typings';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  set manufacturer(manufacturer: Manufacturer) {
    this._manufacturer = manufacturer;
    this.profileForm.controls.description.setValue(manufacturer.description);
    return;
  }

  _manufacturer: Manufacturer | undefined;

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  constructor(
    private fb: UntypedFormBuilder,
    private activateRoute: ActivatedRoute,
    private manufacturerService: ManufacturerService,
    private notificationService: NotificationService,
    private router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog
  ) {
    this.activateRoute.params.subscribe((params) => {
      this.loadProfile(params.id);
    });
  }

  profileForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl()
  });

  loadProfile(id: number) {
    this.loading = true;
    this.manufacturerService
      .search({
        id
      })
      .subscribe((profile) => {
        this.loading = false;
        this.manufacturer = profile.data[0];
      });
  }

  save() {
    if (!this._manufacturer) return;
    this.loading = true;
    this.manufacturerService
      .update({
        description: this.profileForm.value.description,
        id: this._manufacturer.id
      })
      .subscribe((data) => {
        this.loading = false;
        this.manufacturer = data;
        this.notificationService.notice(
          `Производитель ${this._manufacturer?.description} сохранен!`
        );
      });
  }

  delete(dialog?: MatDialogRef<ConfirmComponent>) {
    if (!this._manufacturer) return;
    this.loading = true;
    this.manufacturerService.delete(this._manufacturer.id).subscribe(
      () => {
        this.notificationService.notice(`Производитель ${this._manufacturer?.description} удален!`);
        this.loading = false;
        this.router.navigateByUrl('/catalogue/cars');
        if (dialog) dialog.close();
      },
      (err) => {
        this.loading = false;
        this.notificationService.warning(err.message);
      }
    );
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfirmComponent);
    dialogRef.componentInstance.confirmEvent.subscribe((event) => {
      if (event === false) dialogRef.close();
      if (event === true) this.delete(dialogRef);
    });
  }
}
